import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { NavigationService } from "../services/navigation.service";
import {NavItem} from "../models/NavItem";
import {Navigation} from "../models/Navigation";
import {fadeInAnimation} from "../animations/fade-in.animation";
import {animate, animateChild, query, stagger, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'cir-pub-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInAnimation,
    trigger('fade', [
      transition(':enter', [style({opacity: 0}), animate('.1s ease')])
    ]),
    trigger('stagger', [
      transition('* <=> *', [
          query('*', stagger(100, [animateChild()]), {optional: true})
      ])
    ])
  ]
})
export class LeftNavComponent implements OnInit {

  public navListLoaded: boolean = false;
  public navigation: Navigation[];

  public homeNav: NavItem = new NavItem('Home', '', false);

  constructor(private nav: NavigationService) {
  }

  ngOnInit() {
    this.nav.getLeftNav().subscribe( navItems => {
      this.navigation = navItems;
      this.navListLoaded = true;
    });
  }
}
